
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/Switch.html",
      function () {
        return require("private-next-pages/Forms/Switch.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/Switch.html"])
      });
    }
  